<div class="modal-header">
  <h4 class="modal-title pull-left">{{title}}</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-12">
      <p [innerHTML]="text"></p>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button *ngIf="showCancel" class="btn btn-rbv default" (click)="onCancel()">{{cancelButton}}</button>
  <button class="btn btn-rbv {{actionButtonClass}}" (click)="onConfirm()">{{actionButton}}</button>
</div>
